/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface MessageItem {
  _id: string;
  conversation: string;
  sender: string;
  recipient: string;
  content: string;
  readBy: string[];
  parentMessage: string | null;
  threadRoot: string | null;
  forwardedFrom: string | null;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface MessagesResponse {
  data: MessageItem[];
  pagination: Pagination;
}

const fetchMessagesRequest = async (
  conversationId: string,
  page = 1,
  limit = 20
): Promise<MessagesResponse> =>
  (
    await customAxios.get<MessagesResponse>(
      `/chat/messages?conversationId=${conversationId}&page=${page}&limit=${limit}`
    )
  ).data;

export const useGetMessages = (
  conversationId: string,
  page = 1,
  limit = 20,
  enabled = true
) =>
  useQuery<MessagesResponse, AxiosError>(
    ["messages", conversationId, page, limit],
    () => fetchMessagesRequest(conversationId, page, limit),
    {
      enabled: !!conversationId && enabled,
      onError: (error) =>
        showNotification({
          title: "Error Loading Messages",
          message:
            (error.response?.data as { message?: string })?.message ||
            "Failed to load messages",
          color: "red",
        }),
      retry: 1,
      refetchOnMount: "always",
      staleTime: 0,
    }
  );
